import React, { Component } from "react";
import "./style.css";
import Ink from "react-ink";


export default class TabButton extends Component {
  render() {
    const {
      title,
      icon,
      tabBtnMainContainerClasses = "",
      tabBtnContainerClasses = "",
      iconClasses,
      iconStyles,
      tabBtnMainContainerStyles,
      tabBtnContainerStyles,
      active,
      onClick = function() {}
    } = this.props;

    return (
      <div
        className={`tab-btn-main-container ${tabBtnMainContainerClasses}`}
        style={tabBtnMainContainerStyles}
        onClick={onClick}
      >
        <div
          className={`tab-btn-container ${
            active ? "border-bottom" : ""
          } ${tabBtnContainerClasses}`}
          style={tabBtnContainerStyles}
        >
          <p className="px-2 tab-button-text">{title}</p>
          <img
            src={icon}
            alt=""
            className={`tab-btn-icon ${iconClasses}`}
            style={iconStyles}
          />
          <Ink />
        </div>
      </div>
    );
  }
}
